import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=3ca6330a&"
import script from "./FooterLanding.vue?vue&type=script&lang=js&"
export * from "./FooterLanding.vue?vue&type=script&lang=js&"
import style0 from "./FooterLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports